var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-16-/-Discovery-+-Sharing-/-folder_open_",
    transform: "translate(-1.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.005625, -0.005625)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.0112501,
    height: 18.0112501
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1969922,4.50281247 L10.1313281,4.50281247 L7.87992187,2.25140622 L2.81425779,2.25140622 C1.88169478,2.25140622 1.12570309,3.00739791 1.12570309,3.93996091 L1.12570309,14.0712891 C1.12570309,15.0038521 1.88169478,15.7598437 2.81425779,15.7598437 L15.1969922,15.7598437 C16.1295552,15.7598437 16.8855469,15.0038521 16.8855469,14.0712891 L16.8855469,6.19136717 C16.8855469,5.25880417 16.1295552,4.50281247 15.1969922,4.50281247 Z M3.37710935,4.50281248 L6.94558827,4.50281248 L8.54408672,6.09005389 L9.19699453,6.75421873 L14.6341406,6.75421873 L14.6341406,9.005625 L3.37710935,9.005625 L3.37710935,4.50281248 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.01f29b96a0a3b7dfa91ec2d80250cca0.svg";
export { ForwardRef as ReactComponent };